const eventTarget = new EventTarget();

export const dispatchFinancialsChangeEvent = () => {
  eventTarget.dispatchEvent(new Event('financialsChange'));
};

export const addFinancialsChangeListener = (callback: () => void) => {
  eventTarget.addEventListener('financialsChange', callback);
};

export const removeFinancialsChangeListener = (callback: () => void) => {
  eventTarget.removeEventListener('financialsChange', callback);
};
